import current from './management/current';

const management = [
  {
    path: '/hr/management/current',
    component: () => import('@/page/hr/management/Current.vue'),
    children: [...current],
    meta: {
      name: '인력현황',
      isMenu: false,
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/hr/management/working',
    component: () => import('@/page/hr/management/Working.vue'),
    meta: {
      name: '재직자 관리',
      isMenu: true,
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/hr/management/left',
    component: () => import('@/page/hr/management/Left.vue'),
    meta: {
      name: '퇴직자 관리',
      isMenu: true,
      isActive: false,
      isBread: false,
    },
  },
  {
    path: '/hr/management/receptionbox',
    component: () => import('@/page/hr/management/Receptionbox.vue'),
    meta: {
      name: '수신함',
      isMenu: true,
      isActive: false,
      isBread: false,
    },
  },
];

export default management;
